var map = {
	"./banner-arrow.svg": 16268,
	"./banner-eyes.svg": 1251,
	"./chat-bubble.svg": 29499,
	"./coins.svg": 3768,
	"./diversity.svg": 69755,
	"./document-search.svg": 49794,
	"./dropdown-arrow.svg": 37237,
	"./hand-coins.svg": 88188,
	"./heart-handshake.svg": 92222,
	"./house.svg": 70430,
	"./landmark.svg": 38250,
	"./lightbulb.svg": 43775,
	"./notepad-text.svg": 24175,
	"./pages.svg": 93050,
	"./plant-pot.svg": 71867,
	"./playing-cards-fan.svg": 4406,
	"./settings.svg": 83269,
	"./shield-check.svg": 13154,
	"./shopping-cart.svg": 78401,
	"./toolbox.svg": 8111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42276;